var map = {
	"./map_1.png": "4dc4",
	"./map_10.png": "e79c",
	"./map_11.png": "27f2",
	"./map_12.png": "b209",
	"./map_13.png": "e155",
	"./map_14.png": "4c5b",
	"./map_15.png": "7dac",
	"./map_16.png": "7812",
	"./map_17.png": "cc3b",
	"./map_18.png": "3e63",
	"./map_19.png": "f6e7",
	"./map_2.png": "2f87",
	"./map_20.png": "2784",
	"./map_3.png": "6c26",
	"./map_4.png": "f64a",
	"./map_5.png": "0caa6",
	"./map_6.png": "99ae",
	"./map_7.png": "b3d0",
	"./map_8.png": "c8ec",
	"./map_9.png": "17b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88f9";